<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="nickname">
					<el-input v-model="listQuery.nickname" placeholder="用户昵称" clearable @keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="phone">
					<el-input v-model="listQuery.phone" placeholder="手机号" clearable @keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="card_id">
					<el-select v-model="listQuery.card_id" placeholder="会员卡" clearable @keyup.enter.native="SearchData">
						<el-option v-for="item in cardList" :key="item.id" :label="item.type_name" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="status">
					<el-select v-model="listQuery.status" placeholder="审批状态" clearable @keyup.enter.native="SearchData">
						<el-option label="待审批" value="pending" />
						<el-option label="已驳回" :value="3" />
						<el-option label="已通过" :value="4" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="action-container">
			<el-button-group>
				<el-button v-auth="'UserMemberAddList.create'" type="primary" icon="el-icon-circle-plus-outline"
					@click="openAddMember">新增会员身份</el-button>
			</el-button-group>
		</div>

		<el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%">
			<el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
			<el-table-column align="center" prop="avatar" label="头像" width="88">
				<template slot-scope="{ row }">
					<el-avatar :size="40" :src="row.avatar ? row.avatar : (base_url + 'uploads/default_avatar.png')">
					</el-avatar>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="nickname" label="昵称" min-width="100" />
			<el-table-column align="center" prop="phone" label="手机号" width="120" />
			<el-table-column align="center" prop="card_type_name" label="申请会员卡" min-width="110" />
			<el-table-column align="center" label="会员到期时间" width="160">
				<template slot-scope="{ row }">{{ row.member_end || '—' }}</template>
			</el-table-column>
			<el-table-column align="center" prop="creator_name" label="申请人" width="100" />
			<el-table-column align="center" label="申请时间" width="160">
				<template slot-scope="{ row }">{{ row.create_time | parseTime }}</template>
			</el-table-column>
			<el-table-column align="center" label="状态" width="100">
				<template slot-scope="{ row }">
					<el-tag :type="statusTagType(row.status)" size="small">{{ statusLabel(row.status) }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" width="340">
				<template slot-scope="{ row }">
					<div class="op-rows">
						<el-button v-auth="'UserMemberAddList.detail'" type="primary" plain size="mini" icon="el-icon-view"
							@click="openDetail(row)">详情</el-button>
						<!-- <el-button v-if="canEdit(row)" v-auth="'UserMemberAddList.edit'" type="warning" plain size="mini"
							icon="el-icon-edit" @click="openEdit(row)">编辑</el-button> -->
						<el-button v-if="canLevel1Approve(row)" v-auth="'UserMemberAddList.approve'" type="success" plain
							size="mini" icon="el-icon-s-check" @click="openApprove(row, 1)">审批</el-button>
						<el-button v-if="canLevel2Approve(row)" v-auth="'UserMemberAddList.approve'" type="success" plain
							size="mini" icon="el-icon-s-check" @click="openApprove(row, 2)">审批</el-button>
						<el-button v-if="canDelete(row)" v-auth="'UserMemberAddList.delete'" type="danger" plain size="mini"
							icon="el-icon-delete" @click="handleDelete(row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />

		<!-- 详情 -->
		<el-dialog custom-class="member-add-detail-dialog" title="会员身份新增详情" :visible.sync="detailVisible" width="720px"
			top="10vh" @closed="detailClosed">
			<div v-loading="detailLoading" class="detail-body">
				<template v-if="detailData && !detailLoading">
					<div class="detail-user-card">
						<el-avatar :size="56" :src="detailAvatarSrc">
						</el-avatar>
						<div class="detail-user-meta">
							<div class="detail-user-name">{{ detailData.nickname || '—' }}</div>
							<div class="detail-user-sub">{{ detailData.phone || '—' }}</div>
						</div>
						<div class="detail-status-pill">
							<el-tag :type="statusTagType(detailData.status)" effect="dark" size="medium">
								{{ statusLabel(detailData.status) }}
							</el-tag>
						</div>
					</div>

					<div class="detail-section-title">用户当前会员状态</div>
					<el-descriptions :column="2" border size="small" class="detail-desc">
						<el-descriptions-item label="当前是否为会员">
							{{ detailData.is_member == 1 ? '是' : '否' }}
						</el-descriptions-item>
						<el-descriptions-item label="当前会员卡">
							{{ detailData.member_type_name || '—' }}
						</el-descriptions-item>
						<el-descriptions-item label="当前会员开始时间">
							{{ detailData.user_member_start || '—' }}
						</el-descriptions-item>
						<el-descriptions-item label="当前会员到期时间">
							{{ detailData.user_member_end || '—' }}
						</el-descriptions-item>
					</el-descriptions>

					<div class="detail-section-title">申请信息</div>
					<el-descriptions :column="2" border size="small" class="detail-desc">
						<el-descriptions-item label="申请会员卡">
							{{ detailData.card_type_name || '—' }}
						</el-descriptions-item>
						<el-descriptions-item label="申请开始时间">
							{{ detailData.member_start || '—' }}
						</el-descriptions-item>
						<el-descriptions-item label="申请到期时间">
							{{ detailData.member_end || '—' }}
						</el-descriptions-item>
						<el-descriptions-item v-if="detailData.remark" label="备注" :span="2">
							{{ detailData.remark }}
						</el-descriptions-item>
					</el-descriptions>

					<div class="detail-section-title">申请与审批</div>
					<el-descriptions :column="2" border size="small" class="detail-desc">
						<el-descriptions-item label="申请人">{{ detailData.creator_name || '—' }}</el-descriptions-item>
						<el-descriptions-item label="申请时间">{{ formatTs(detailData.create_time) }}</el-descriptions-item>
						<el-descriptions-item label="一级审批人">
							{{ detailData.level1_admin_name || (detailData.level1_admin_id ? 'ID ' + detailData.level1_admin_id : '—') }}
						</el-descriptions-item>
						<el-descriptions-item label="二级审批人">
							{{ detailData.level2_admin_name || (detailData.level2_admin_id ? 'ID ' + detailData.level2_admin_id : '—') }}
						</el-descriptions-item>
					</el-descriptions>

					<div class="detail-section-title">审批进度</div>
					<el-timeline class="detail-timeline">
						<el-timeline-item :timestamp="formatTs(detailData.create_time)" placement="top" type="primary">
							<div class="tl-title">提交申请</div>
							<div class="tl-sub">{{ detailData.creator_name || '—' }}</div>
						</el-timeline-item>
						<el-timeline-item v-if="detailData.level1_time || detailData.level1_result"
							:timestamp="formatTs(detailData.level1_time)" placement="top"
							:type="timelineType(detailData.level1_result)">
							<div class="tl-title">一级审批{{ approveResultSuffix(detailData.level1_result) }}</div>
							<div class="tl-sub">{{ detailData.level1_admin_name || '—' }}</div>
						</el-timeline-item>
						<el-timeline-item v-if="detailData.level2_time || detailData.level2_result"
							:timestamp="formatTs(detailData.level2_time)" placement="top"
							:type="timelineType(detailData.level2_result)">
							<div class="tl-title">二级审批{{ approveResultSuffix(detailData.level2_result) }}</div>
							<div class="tl-sub">{{ detailData.level2_admin_name || '—' }}</div>
						</el-timeline-item>
						<el-timeline-item v-if="detailData.status === 3 && detailData.reject_remark"
							:timestamp="formatTs(rejectTs(detailData))" placement="top" type="danger">
							<div class="tl-title">驳回说明</div>
							<div class="tl-reject">
								<span class="tl-reject-level">{{ rejectLevelLabel(detailData.reject_level) }}</span>
								{{ detailData.reject_remark }}
							</div>
						</el-timeline-item>
					</el-timeline>
				</template>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="detailVisible = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog title="编辑会员身份新增申请" :visible.sync="editVisible" width="560px" top="12vh" @closed="editClosed">
			<el-form ref="editForm" :model="editForm" :rules="editRules" label-width="110px" style="padding: 10px 10px 0 0;">
				<el-form-item label="目标用户">
					<el-input :value="editForm.nickname + '（' + editForm.phone + '）'" disabled />
				</el-form-item>
				<el-form-item label="会员卡" prop="card_id">
					<el-select v-model="editForm.card_id" placeholder="请选择会员卡" style="width: 100%;">
						<el-option v-for="item in cardList" :key="item.id" :label="item.type_name" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="到期时间" prop="member_end">
					<el-date-picker v-model="editForm.member_end" type="datetime" placeholder="请选择到期时间"
						value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
				</el-form-item>
				<el-form-item label="备注说明">
					<el-input v-model="editForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit
						placeholder="选填" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editVisible = false">取消</el-button>
				<el-button type="primary" :loading="editLoading" @click="submitEdit">保存</el-button>
			</div>
		</el-dialog>

		<!-- 审批 -->
		<el-dialog :title="approveTitle" :visible.sync="approveVisible" width="480px" @closed="approveClosed">
			<el-form ref="approveForm" :model="approveForm" label-width="100px">
				<el-form-item label="审批结果" required>
					<el-radio-group v-model="approveForm.result">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="2">驳回</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="approveForm.result === 2" label="驳回原因" required>
					<el-input v-model="approveForm.reject_remark" type="textarea" :rows="3" maxlength="500" show-word-limit />
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="approveVisible = false">取消</el-button>
				<el-button type="primary" :loading="approveLoading" @click="submitApprove">确定</el-button>
			</div>
		</el-dialog>

		<!-- 新增会员身份 -->
		<el-dialog title="新增会员身份" :visible.sync="addMemberVisible" v-if="addMemberVisible" width="560px" top="12vh"
			@closed="addMemberClosed">
			<el-form ref="addMemberForm" :model="addMemberForm" :rules="addMemberRules" label-width="100px"
				style="padding: 10px 10px 0 0;">
				<el-form-item label="目标用户" prop="user_id">
					<div v-if="addMemberForm.user_id && addMemberForm.nickname" class="selected-user-card">
						<el-avatar :size="40" :src="addMemberForm.avatar" @error="true">
							<img :src="base_url + 'uploads/default_avatar.png'" alt="">
						</el-avatar>
						<div class="selected-user-info">
							<div class="selected-user-name">{{ addMemberForm.nickname }}</div>
							<div class="selected-user-phone">{{ addMemberForm.phone }}</div>
						</div>
						<el-button type="text" @click="clearSelectedUser">更换</el-button>
					</div>
					<el-button v-else type="primary" plain icon="el-icon-search" @click="openUserSelectDialog">选择用户</el-button>
				</el-form-item>
				<el-form-item label="会员卡" prop="card_id">
					<el-select v-model="addMemberForm.card_id" placeholder="请选择会员卡" style="width: 100%;">
						<el-option v-for="item in cardList" :key="item.id" :label="item.type_name" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="到期时间" prop="member_end">
					<el-date-picker v-model="addMemberForm.member_end" type="datetime" placeholder="请选择到期时间"
						value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="addMemberForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit
						placeholder="选填" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addMemberVisible = false">取消</el-button>
				<el-button type="primary" :loading="addMemberLoading" @click="confirmAddMember">提交审批</el-button>
			</div>
		</el-dialog>

		<!-- 选择用户弹窗 -->
		<el-dialog custom-class="user-select-dialog" title="选择用户" :visible.sync="userSelectVisible" width="780px" top="10vh"
			@closed="userSelectClosed">
			<div class="user-search-box">
				<el-input v-model="userSearchKeyword" placeholder="请输入昵称或手机号搜索" clearable @keyup.enter.native="doUserSearch"
					style="width: 240px; margin-right: 8px;">
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<el-button type="primary" icon="el-icon-search" @click="doUserSearch">搜索</el-button>
				<el-button icon="el-icon-refresh" @click="resetUserSearch">重置</el-button>
			</div>
			<div v-loading="userSearchLoading" class="user-list-box">
				<el-table :data="userSearchResults" style="width: 100%" size="small">
					<el-table-column label="用户" min-width="180">
						<template slot-scope="{ row }">
							<div class="user-cell">
								<el-avatar :size="32" :src="row.avatar ? row.avatar : (base_url + 'uploads/default_avatar.png')">
								</el-avatar>
								<div class="user-cell-info">
									<div class="user-cell-name">{{ row.nickname || '—' }}</div>
									<div class="user-cell-phone">{{ row.phone || '—' }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="会员状态" width="90" align="center">
						<template slot-scope="{ row }">
							<el-tag :type="row.is_member == 1 ? 'success' : 'info'" size="mini">
								{{ row.is_member == 1 ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="会员级别" width="120" align="center">
						<template slot-scope="{ row }">
							<span class="member-level">{{ row.member_type_name || '—' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="到期时间" width="160" align="center">
						<template slot-scope="{ row }">
							<span class="member-expire">{{ row.member_end || '—' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="80" align="center">
						<template slot-scope="{ row }">
							<el-button type="primary" size="mini" @click="selectUser(row)">选择</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="user-pagination">
					<pagination v-show="userTotal > 0" :total="userTotal" :page.sync="userQuery.page"
						:limit.sync="userQuery.limit" :layout="'prev, pager, next'" @pagination="loadUserList" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="userSelectVisible = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Pagination from '@/components/Pagination'
	import {
		listMemberAdd,
		detailMemberAdd,
		editMemberAdd,
		level1ApproveMemberAdd,
		level2ApproveMemberAdd,
		deleteMemberAdd,
		submitMemberAdd
	} from '@/api/user/memberAdd'
	import {
		parseTime
	} from '@/utils'
	import typeapi from '@/api/card'
	import userApi from '@/api/user'

	export default {
		name: 'MemberAddList',
		components: {
			Pagination
		},
		data() {
			return {
				base_url: process.env.VUE_APP_BASE_API,
				list: [],
				total: 0,
				listLoading: false,
				listQuery: {
					page: 1,
					limit: 15,
					order: 'desc',
					sort: 'a.id',
					nickname: '',
					phone: '',
					card_id: null,
					status: null
				},
				cardList: [],
				detailVisible: false,
				detailLoading: false,
				detailData: null,
				editVisible: false,
				editLoading: false,
				editForm: {
					id: null,
					user_id: null,
					nickname: '',
					phone: '',
					card_id: null,
					member_end: '',
					remark: ''
				},
				editRules: {
					card_id: [{
						required: true,
						message: '请选择会员卡',
						trigger: 'change'
					}],
					member_end: [{
						required: true,
						message: '请选择到期时间',
						trigger: 'change'
					}]
				},
				approveVisible: false,
				approveLoading: false,
				approveRow: null,
				approveAsLevel: 1,
				approveForm: {
					result: 1,
					reject_remark: ''
				},
				userSelectVisible: false,
				userSearchKeyword: '',
				userSearchLoading: false,
				userSearchResults: [],
				userTotal: 0,
				userQuery: {
					page: 1,
					limit: 10
				},
				addMemberVisible: false,
				addMemberLoading: false,
				addMemberForm: {
					user_id: null,
					nickname: '',
					phone: '',
					avatar: '',
					card_id: null,
					member_end: '',
					remark: ''
				},
				addMemberRules: {
					user_id: [{
						required: true,
						message: '请选择用户',
						trigger: 'change'
					}],
					card_id: [{
						required: true,
						message: '请选择会员卡',
						trigger: 'change'
					}],
					member_end: [{
						required: true,
						message: '请选择到期时间',
						trigger: 'change'
					}]
				}
			}
		},
		computed: {
			...mapGetters(['current_user']),
			approveTitle() {
				return this.approveAsLevel === 2 ? '二级审批' : '一级审批'
			},
			detailAvatarSrc() {
				return this.detailData?.avatar || this.base_url + 'uploads/default_avatar.png'
			}
		},
		created() {
			this.loadData()
			this.getCardList()
		},
		methods: {
			getCardList() {
				typeapi.CardList().then(res => {
					this.cardList = res.data || []
				})
			},
			indexMethod(index) {
				return index + 1 + (this.listQuery.page - 1) * this.listQuery.limit
			},
			statusLabel(s) {
				const m = {
					1: '待审批',
					2: '待审批',
					3: '已驳回',
					4: '已通过'
				}
				return m[s] || '—'
			},
			statusTagType(s) {
				const m = {
					1: 'warning',
					2: 'warning',
					3: 'danger',
					4: 'success'
				}
				return m[s] || 'info'
			},
			canEdit(row) {
				if (row.status === 4) return false
				const aid = this.current_user && this.current_user.id != null ? Number(this.current_user.id) : -1
				return Number(row.creator_id) === aid
			},
			canDelete(row) {
				return row.status !== 4
			},
			canLevel1Approve(row) {
				const aid = this.current_user && this.current_user.id != null ? Number(this.current_user.id) : -1
				if (row.status === 3 || row.status === 4) return false
				if (row.status === 2) return false
				return row.status === 1 && Number(row.level1_admin_id) === aid && Number(row.level1_result) !== 1
			},
			canLevel2Approve(row) {
				const aid = this.current_user && this.current_user.id != null ? Number(this.current_user.id) : -1
				if (row.status === 3 || row.status === 4) return false
				if (row.status === 2) {
					return Number(row.level2_admin_id) === aid && Number(row.level2_result) !== 1
				}
				return row.status === 1 && Number(row.level2_admin_id) === aid && Number(row.level2_result) !== 1
			},
			loadData() {
				this.listLoading = true
				listMemberAdd(this.listQuery)
					.then(res => {
						this.list = (res.data && res.data.items) ? res.data.items : []
						this.total = (res.data && res.data.total) ? res.data.total : 0
					})
					.finally(() => {
						this.listLoading = false
					})
			},
			SearchData() {
				this.listQuery.page = 1
				this.loadData()
			},
			resetQuery() {
				this.listQuery.nickname = ''
				this.listQuery.phone = ''
				this.listQuery.card_id = null
				this.listQuery.status = null
				this.listQuery.page = 1
				this.loadData()
			},
			openDetail(row) {
				this.detailVisible = true
				this.detailData = null
				this.detailLoading = true
				detailMemberAdd({
						id: row.id
					})
					.then(res => {
						this.detailData = (res && res.data) ? res.data : null
					})
					.finally(() => {
						this.detailLoading = false
					})
			},
			detailClosed() {
				this.detailData = null
			},
			openEdit(row) {
				this.editForm = {
					id: row.id,
					user_id: row.user_id,
					nickname: row.nickname || '',
					phone: row.phone || '',
					card_id: row.card_id,
					member_end: row.member_end,
					remark: row.remark || ''
				}
				this.editVisible = true
			},
			editClosed() {
				this.$refs.editForm && this.$refs.editForm.clearValidate()
			},
			submitEdit() {
				this.$refs.editForm.validate(valid => {
					if (!valid) return
					const endTime = new Date(this.editForm.member_end).getTime()
					if (endTime <= Date.now()) {
						this.$message.warning('到期时间必须大于当前时间')
						return
					}
					this.editLoading = true
					editMemberAdd({
							id: this.editForm.id,
							card_id: this.editForm.card_id,
							member_end: this.editForm.member_end,
							remark: this.editForm.remark
						})
						.then(() => {
							this.$message.success('保存成功')
							this.editVisible = false
							this.loadData()
						})
						.finally(() => {
							this.editLoading = false
						})
				})
			},
			formatTs(ts) {
				if (!ts) return '—'
				return parseTime(ts) || '—'
			},
			approveResultSuffix(r) {
				if (r === 1) return ' · 通过'
				if (r === 2) return ' · 驳回'
				return ''
			},
			timelineType(r) {
				if (r === 1) return 'success'
				if (r === 2) return 'danger'
				return 'primary'
			},
			rejectLevelLabel(lvl) {
				if (lvl === 1) return '【一级驳回】'
				if (lvl === 2) return '【二级驳回】'
				return ''
			},
			rejectTs(d) {
				if (!d) return 0
				if (d.reject_level === 1 && d.level1_time) return d.level1_time
				if (d.reject_level === 2 && d.level2_time) return d.level2_time
				return d.update_time
			},
			openApprove(row, level) {
				this.approveRow = row
				this.approveAsLevel = level === 2 ? 2 : 1
				this.approveForm = {
					result: 1,
					reject_remark: ''
				}
				this.approveVisible = true
			},
			approveClosed() {
				this.approveRow = null
				this.approveAsLevel = 1
			},
			handleDelete(row) {
				this.$confirm('确定删除该会员身份新增记录吗？', '删除确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteMemberAdd({
						id: row.id
					}).then(() => {
						this.$message.success('删除成功')
						this.loadData()
					})
				}).catch(() => {})
			},
			submitApprove() {
				const {
					result,
					reject_remark
				} = this.approveForm
				if (result === 2 && !String(reject_remark || '').trim()) {
					this.$message.warning('驳回时请填写驳回原因')
					return
				}
				if (!this.approveRow) return
				const payload = {
					id: this.approveRow.id,
					result,
					reject_remark
				}
				this.approveLoading = true
				const req = this.approveAsLevel === 2 ?
					level2ApproveMemberAdd(payload) :
					level1ApproveMemberAdd(payload)
				req.then(() => {
						this.$message.success('操作成功')
						this.approveVisible = false
						this.loadData()
					})
					.finally(() => {
						this.approveLoading = false
					})
			},
			openAddMember() {
				this.addMemberForm = {
					user_id: null,
					nickname: '',
					phone: '',
					avatar: '',
					card_id: null,
					member_end: '',
					remark: ''
				}
				this.addMemberVisible = true
			},
			addMemberClosed() {
				this.$refs.addMemberForm && this.$refs.addMemberForm.clearValidate()
			},
			openUserSelectDialog() {
				this.userSearchKeyword = ''
				this.userSearchResults = []
				this.userTotal = 0
				this.userQuery.page = 1
				this.userSelectVisible = true
				this.loadUserList()
			},
			loadUserList() {
				this.userSearchLoading = true
				const params = {
					page: this.userQuery.page,
					limit: this.userQuery.limit
				}
				if (this.userSearchKeyword && this.userSearchKeyword.trim()) {
					params.keyword = this.userSearchKeyword.trim()
				}
				userApi.Query(params).then(res => {
					this.userSearchResults = (res.data && res.data.items) ? res.data.items : []
					this.userTotal = (res.data && res.data.total) ? res.data.total : 0
				}).finally(() => {
					this.userSearchLoading = false
				})
			},
			userSelectClosed() {
				this.userSearchKeyword = ''
				this.userSearchResults = []
				this.userTotal = 0
				this.userQuery.page = 1
			},
			doUserSearch() {
				this.userQuery.page = 1
				this.loadUserList()
			},
			resetUserSearch() {
				this.userSearchKeyword = ''
				this.userQuery.page = 1
				this.loadUserList()
			},
			selectUser(user) {
				this.addMemberForm.user_id = user.id
				this.addMemberForm.nickname = user.nickname
				this.addMemberForm.phone = user.phone
				this.addMemberForm.avatar = user.avatar
				this.userSelectVisible = false
			},
			clearSelectedUser() {
				this.addMemberForm.user_id = null
				this.addMemberForm.nickname = ''
				this.addMemberForm.phone = ''
				this.addMemberForm.avatar = ''
			},
			confirmAddMember() {
				this.$refs.addMemberForm.validate(valid => {
					if (!valid) return
					const endTime = new Date(this.addMemberForm.member_end).getTime()
					if (endTime <= Date.now()) {
						this.$message.warning('到期时间必须大于当前时间')
						return
					}
					this.addMemberLoading = true
					submitMemberAdd({
							user_id: this.addMemberForm.user_id,
							card_id: this.addMemberForm.card_id,
							member_end: this.addMemberForm.member_end,
							remark: this.addMemberForm.remark
						})
						.then(() => {
							this.$message.success('提交成功，状态：待审批')
							this.addMemberVisible = false
							this.loadData()
						})
						.finally(() => {
							this.addMemberLoading = false
						})
				})
			}
		}
	}
</script>

<style scoped>
	.op-rows {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		justify-content: center;
	}

	.detail-body {
		min-height: 100px;
	}

	.detail-user-card {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 18px 20px;
		margin-bottom: 8px;
		border-radius: 10px;
		background: linear-gradient(125deg, #f0f9ff 0%, #ecfdf5 55%, #f9f8f4 100%);
		border: 1px solid #ebeef5;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
	}

	.detail-user-meta {
		flex: 1;
		min-width: 0;
	}

	.detail-user-name {
		font-size: 17px;
		font-weight: 600;
		color: #303133;
		line-height: 1.4;
	}

	.detail-user-sub {
		margin-top: 4px;
		font-size: 13px;
		color: #909399;
	}

	.detail-status-pill {
		flex-shrink: 0;
	}

	.detail-section-title {
		margin: 18px 0 10px;
		padding-left: 10px;
		font-size: 14px;
		font-weight: 600;
		color: #606266;
		border-left: 3px solid #67c23a;
		line-height: 1.2;
	}

	.detail-desc {
		margin-bottom: 4px;
	}

	.detail-timeline {
		margin-top: 4px;
		padding-left: 2px;
	}

	.tl-title {
		font-weight: 600;
		color: #303133;
		margin-bottom: 4px;
	}

	.tl-sub {
		font-size: 13px;
		color: #909399;
	}

	.tl-reject {
		font-size: 13px;
		color: #606266;
		line-height: 1.6;
	}

	.tl-reject-level {
		display: inline-block;
		margin-right: 6px;
		color: #f56c6c;
		font-weight: 600;
	}

	.selected-user-card {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 10px 12px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background: #f5f7fa;
	}

	.selected-user-info {
		flex: 1;
	}

	.selected-user-name {
		font-size: 14px;
		font-weight: 600;
		color: #303133;
	}

	.selected-user-phone {
		font-size: 12px;
		color: #909399;
		margin-top: 2px;
	}

	.user-search-box {
		margin-bottom: 12px;
		display: flex;
		align-items: center;
	}

	.user-list-box {
		height: 480px;
		overflow-y: auto;
	}

	.user-pagination {
		padding: 12px 0 4px;
		text-align: right;
	}

	.user-cell {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.user-cell-info {
		flex: 1;
		min-width: 0;
		text-align: left;
	}

	.user-cell-name {
		font-size: 14px;
		font-weight: 500;
		color: #303133;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.user-cell-phone {
		font-size: 12px;
		color: #909399;
		margin-top: 2px;
	}

	.member-level {
		font-size: 13px;
		color: #606266;
	}

	.member-expire {
		font-size: 13px;
		color: #606266;
	}

	.user-empty {
		padding: 40px 0;
		text-align: center;
		color: #909399;
		font-size: 14px;
	}

	.user-item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px 16px;
		cursor: pointer;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s;
	}

	.user-item:last-child {
		border-bottom: none;
	}

	.user-item:hover {
		background-color: #f5f7fa;
	}

	.user-item-info {
		flex: 1;
	}

	.user-item-name {
		font-size: 14px;
		font-weight: 500;
		color: #303133;
	}

	.user-item-phone {
		font-size: 12px;
		color: #909399;
		margin-top: 2px;
	}
</style>

<style>
	.member-add-detail-dialog .el-dialog__body {
		padding: 12px 20px 8px;
		max-height: calc(100vh - 320px);
		overflow-y: auto;
	}

	.user-select-dialog .el-dialog__body {
		padding: 16px 20px;
		max-height: 620px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
</style>